import React, { useState, useContext, useEffect } from "react";
import "./splitBillDetails.scss";
import { useHistory } from "react-router-dom";

// material ui
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
// localizations
import { withTranslation, useTranslation, Trans } from "react-i18next";
// redux
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { get_lang } from "../../Functions/getLang";
import PartialPaymentSummary from "../partialPaymentSummary/PartialPaymentSummary";


function SplitBillDetails(props) {
  const { t } = useTranslation();
  const { splitBillAmount, setSplitBillAmount, subTotal, paidAmount, orders, combos, partialType, setPartialType, setPayWithValue, goBackMain, invoiceDetails } = props;
  // // console.log(orders)
  const remainingAmount = subTotal - paidAmount
  const [open, setOpen] = React.useState(false);
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const handleSplitBill = () => {

    appDispatch({
      type: "setSplitBill",
      splitBill: true,
    });
    localStorage.setItem("splitBill", Boolean(true))
    setPartialType('directBill')
    // console.log(typeof subTotal)
    setSplitBillAmount(parseFloat(remainingAmount))
  }

  const handleShowSplitBillOptions = () => {
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: true,
    });
    localStorage.setItem("splitBillOptions", Boolean(true))
  }

  const editSplit = () => {
    let flag = true
    setPayWithValue('')
    appDispatch({
      type: "setSplitBill",
      splitBill: false,
    });
    localStorage.removeItem("splitBill")

    if (partialType == "product") {
      appDispatch({
        type: "setPayForItems",
        payForItems: true,
      });
      localStorage.setItem("payForItems", Boolean(true))
    }
    else if (partialType == "ratio") {
      appDispatch({
        type: "setDivideBill",
        divideBill: true,
      });
      localStorage.setItem("divideBill", Boolean(true))
    }
    else if (partialType == "customer") {
      appDispatch({
        type: "setPayCustomAmount",
        payCustomAmount: true,
      });
      localStorage.setItem("payCustomAmount", Boolean(true))
    }
    else{
      goBackMain();
      flag = false;
    }
  
   if(flag){
    appDispatch({
      type: "setSplitBillOptions",
      splitBillOptions: true,
    });
    localStorage.setItem("splitBillOptions", Boolean(true))
   }
  }


  useEffect(() => {
    if (localStorage.getItem("splitBillOptions")) {
      appDispatch({
        type: "setSplitBillOptions",
        splitBillOptions: localStorage.getItem("splitBillOptions"),
      });
    } else {
      appDispatch({
        type: "setSplitBillOptions",
        splitBillOptions: true,
      });
    }
  }, [])


  return (
    <>
      <div
        className={`splitBillDetails   ${appState.langValue == "ar" ? "splitBillDetailsArabic" : " "
          }`}
      >
        <div className="container-fluid content pb-3 mt-3 bg-white" >
          <h1
            className={` ${appState.langValue === "ar"
                ? "text-right familyGraphikArabic800 "
                : " familyPoppins600"
              }`}
          >
            {t("invoice.Pay-your-Bill")}
          </h1>

          <div className="d-flex  align-items-center py-2 w-100 justify-content-between ">
            <h5
              className={` totalAmountChild mb-0  ${appState.langValue === "ar" ? "text-right" : "familyPoppins"
                }`}
            >
              {t("invoice.Subtotal")}
            </h5>
            <h5
              className={` totalAmountChild mb-0 ${appState.langValue === "ar" ? "text-right" : "familyPoppins500"
                }`}
            >
              <span className="px-1">{subTotal.toFixed(3)}</span>
              <span className="px-1">{t("KWD")}</span>{" "}
            </h5>
          </div>

          <div className="d-flex  align-items-center py-2 w-100 justify-content-between ">
            <h5
              className={` totalAmountChild mb-0  ${appState.langValue === "ar" ? "text-right" : "familyPoppins"
                }`}
            >
               {t("invoice.You-Paid")}:
            </h5>
            <h5
              className={` totalAmountChild mb-0 ${appState.langValue === "ar" ? "text-right" : "familyPoppins500"
                }`}
            >
              <span className="px-1">{paidAmount.toFixed(3)}</span>
              <span className="px-1">{t("KWD")}</span>{" "}
            </h5>
          </div>

          <div className="d-flex  align-items-center py-3 w-100 justify-content-between ">
            <h5
              className={` totalAmount mb-0  ${appState.langValue === "ar" ? "text-right" : "familyPoppins600"
                }`}
            >
              {t("invoice.Left-to-Pay")}
            </h5>
            <h5
              className={` totalAmount mb-0 ${appState.langValue === "ar" ? "text-right" : "familyPoppins600"
                }`}
            >
              <span className="px-1">{remainingAmount.toFixed(3)}</span>
              <span className="px-1">{t("KWD")}</span>{" "}
            </h5>
          </div>

          <PartialPaymentSummary invoiceDetails={invoiceDetails} />

          {/* <div className="d-flex paidAmountParent  align-items-center py-3 w-100 justify-content-between  ">
            <div className="d-flex align-items-center">
              {" "}
              <Button disabled className="IconColor" variant="contained">
                <PersonOutlineIcon className="px-1 textWhite" />
              </Button>{" "}
              <h5
                className={` totalAmountChild mb-0  px-3 ${appState.langValue === "ar" ? "text-right" : "familyPoppins"
                  }`}
              >
                {t("invoice.You-Paid")}:
              </h5>
            </div>

            <h5
              className={` totalAmount mb-0 ${appState.langValue === "ar" ? "text-right" : "familyPoppins600"
                }`}
            >
              <span className="px-1"> {paidAmount.toFixed(3)}</span>
              <span className="px-1">{t("KWD")}</span>{" "}
            </h5>
          </div> */}

          <h1
            className={` ${appState.langValue === "ar"
                ? "text-right familyGraphikArabic800 "
                : " familyPoppins600"
              }`}
          >
            {t("invoice.List-of-items")}
          </h1>
          {orders.map((order, i) => {
            return (
              order.status != "Rejected" &&
              <div className="d-flex paidAmountParent align-items-center py-3 w-100 justify-content-between ">
                <div className="d-flex align-items-center">
                  <Button
                    disabled
                    className="ListIconColor"
                    variant="contained"
                  >
                    <p className="px-1  m-0"> {order.quantity}</p>
                  </Button>
                  <h5
                    className={` totalAmount mb-0  px-3 ${appState.langValue === "ar"
                        ? "text-right"
                        : "familyManrope800"
                      }`}
                  >
                    {get_lang(order.product.name, appState.langValue)}

                    
                  </h5>
                </div>

                <div>
                <h5
                  className={` totalAmount d-flex align-items-center mb-0 ${appState.langValue === "ar"
                      ? "text-right"
                      : "familyManrope800"
                    }`}
                >
                  { order.addons.length > 0 &&
                    <span className="text-muted">
                    <span className="px-1"> {order.sum_addons.toFixed(3)}</span>
                    <span className="px-1">{t("KWD")}</span>{" "}
                    </span>
                  }

                  <span >
                  <span className="px-1"> {order.total.toFixed(3)}</span>
                  <span className="px-1">{t("KWD")}</span>{" "}
                  </span>
              
                </h5>
                {order.discount > 0 &&   
                 <h5
                  className={` totalAmount justify-content-end d-flex align-items-center mb-0 ${appState.langValue === "ar"
                      ? "text-right"
                      : "familyManrope800"
                    }`}
                >
                  { order.discount > 0  > 0 &&
                    <span className="text-danger">
                    <span className="px-1">{appState.langValue === "en"&&<span>-</span>}{order.discount.toFixed(3)}{appState.langValue === "ar"&&<span>-</span>}</span>
                    <span className="px-1">{t("KWD")}</span>{" "}
                    </span>
                  }
                </h5>}
             
                </div>
               
               
              </div>
            );
          })}


                      {combos.length > 0 &&
                        combos.map((combo, i) => {
                  return(
                    combo?.status != 'Rejectd' &&
                    <div className="d-flex paidAmountParent align-items-center py-3 w-100 justify-content-between ">
          <div className="d-flex align-items-center">
            <Button
              disabled
              className="ListIconColor"
              variant="contained"
            >
              <p className="px-1  m-0"> {combo.quantity}</p>
            </Button>
            <h5
              className={` totalAmount mb-0  px-3 ${appState.langValue === "ar"
                  ? "text-right"
                  : "familyManrope800"
                }`}
            >
               {get_lang( combo.combo?.name, appState.langValue )}
            </h5>
          </div>

          <div>
          <h5
            className={` totalAmount d-flex align-items-center mb-0 ${appState.langValue === "ar"
                ? "text-right"
                : "familyManrope800"
              }`}
          >
            {/* { combo?.addons.length > 0 &&
              <span className="text-muted">
              <span className="px-1"> {combo.sum_addons.toFixed(3)}</span>
              <span className="px-1">{t("KWD")}</span>{" "}
              </span>
            } */}

            <span >
            <span className="px-1"> {combo.total.toFixed(3)}</span>
            <span className="px-1">{t("KWD")}</span>{" "}
            </span>
        
          </h5>
          {combo.discount > 0 &&   
           <h5
            className={` totalAmount justify-content-end d-flex align-items-center mb-0 ${appState.langValue === "ar"
                ? "text-right"
                : "familyManrope800"
              }`}
          >
            { combo.discount > 0  > 0 &&
              <span className="text-danger">
              <span className="px-1">{appState.langValue === "en"&&<span>-</span>}{combo.discount.toFixed(3)}{appState.langValue === "ar"&&<span>-</span>}</span>
              <span className="px-1">{t("KWD")}</span>{" "}
              </span>
            }
          </h5>}
       
          </div>
         
         
        </div>
                  )
              ////////////////////////////////////////////////////////////////////////////////////////////////

                        })}

          {appState.splitBillOptions ||
            appState.payForItems ||
            appState.divideBill ||
            appState.payCustomAmount || appState.splitBill ? <Button
              onClick={editSplit}
              className={` py-3 px-4 mt-3 confirmBtn justify-content-center align-items-center   ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                }`}
            >
            {" "}
            <span className="text-capitalize">{t("invoice.Edit-Split")}</span>{" "}
          </Button> : ""}


          {appState.splitBillOptions ||
            appState.payForItems ||
            appState.divideBill ||
            appState.payCustomAmount ||
            appState.splitBill ? (
            " "
          ) : (
            <div className="bottomBtn py-3 px-2 bg-white" >
              <Button
                onClick={handleShowSplitBillOptions}

                className={` py-3 px-4 text-center splitBtn mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                  }`}
              >
                {" "}
                <span className="text-capitalize text-center ">   {t("invoice.Split-Bill")}</span>{" "}
              </Button>
              <Button
                onClick={handleSplitBill}
                className={` py-3 px-4 mt-3 deletebtn justify-content-between align-items-center   ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                  }`}
              >
                {" "}
                <span className="text-capitalize">   {t("invoice.pay")} </span>{" "}
                <span>   <span className="px-3"> {remainingAmount.toFixed(3)} {t("KWD")} </span>{" "}
                  {appState.langValue == "ar" ? <ArrowBackIosIcon /> : <ArrowForwardIosIcon />}       </span>

              </Button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}



export default withTranslation()(SplitBillDetails);